import { FaCog } from "react-icons/fa";
import "../css/TableColumnSettingsModal.css";

/** Nút mở popup cài đặt ẩn/hiện cột — dùng chung nhiều màn hình. */
export default function TableColumnSettingsButton({ onClick, disabled, className = "" }) {
  return (
    <div className={`table-setting table-col-settings-trigger ${className}`.trim()}>
      <button
        type="button"
        className="btn btn-sm btn-light border"
        title="Cài đặt hiển thị cột"
        onClick={onClick}
        disabled={disabled}
      >
        <FaCog size={14} />
      </button>
    </div>
  );
}
